export const environment = {
  production: true,
  url: 'https://physiolife-api.smartlaboman.com/cms/api/v1/',
  server: 'https://physiolife-api.smartlaboman.com/',
  glitchtipDsn: 'https://7e469e4d67904e3bbf0d3652ca663752@glitchtip.alsaadi.xyz/20',
  glitchtipRelease: ''
};
